<template>
    <v-select
        dense
        outlined
        v-bind="$attrs"
        :items="items"
        multiple
        chips
        deletable-chips
        small-chips
        item-text="name"
        item-value="id"
        v-on="$listeners"
    />
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'DossierSelect',

    computed: {
        ...mapState('dossier', {
            loaded: 'loaded',
            collection: 'collection',
        }),

        items() {
            // here we could filter the models, if needed
            return this.collection ? this.collection.models : [];
        },
    },

    mounted() {
        this.loadData();
    },

    methods: {
        ...mapActions('dossier', {
            loadData: 'load',
        }),
        reload() {
            this.loadData({ force: true });
        },
    },
};
</script>
